import React from "react";
import ReactDOM from "react-dom";
import PropTypes from "prop-types";
import axios from "axios";

import Comment from "./Comment";
import CommentForm from "./CommentForm";

class CommentsBox extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            comments: []
        };
        this.fetchComments = this.fetchComments.bind(this);
    }
    componentDidMount(){
        this.fetchComments();
    }
    fetchComments(){
        axios.get(`/api/blog/${this.props.postId}/comments`)
            .then((result)=>{
                this.setState({
                    comments: result.data.items
                });
            }).catch((err)=>{
                console.error(err);
            })
        ;
    }
    render(){
        return(
            <div className="post-comments-box">
                <CommentForm />
                <h2 className="title">{`${this.state.comments.length} Comments`}</h2>
                <ul className="list-unstyled">
                    {
                        this.state.comments.map((comment)=>{
                            return <Comment key={comment.comment_id} user={comment.user_name} email={comment.user_email} content={comment.content} date={comment.creation_time} />;
                        })
                    }
                </ul>
            </div>
        );
    }
}

CommentsBox.propTypes = {
    postId: PropTypes.string.isRequired
};


const commentsBoxNode = document.querySelector("#comments-box");

if (commentsBoxNode) {
    ReactDOM.render(<CommentsBox postId={commentsBoxNode.dataset.post} />, commentsBoxNode);
}
